const getters = {
  SDKComponentMessage: state => state.SDKComponent.SDKComponentMessage,
  floatBall: state => state.SDKComponent.floatBall,
  notice: state => state.SDKComponent.notice,
  sdkNotice: state => state.SDKComponent.sdkNotice,
  rechargeAges: state => state.SDKComponent.rechargeAges,
  slideBar: state => state.SDKComponent.slideBar,
  iframe: state => state.SDKComponent.iframe,
  token: state => state.SDKComponent.token,
  screen: state => state.SDKComponent.screen,
  kefu: state => state.SDKComponent.kefu,
  islandscape: state => state.SDKComponent.islandscape,
  isShowIosGuide: state => state.SDKComponent.isShowIosGuide,
  isBallMove: state => state.SDKComponent.isBallMove,
}

export default getters
